import { useRouter } from "next/router";
import { useDeepLinks } from "src/hooks/useDeepLinks";
import { DeepLinkType } from "pages/api/deep-links/types";
import { useApplicationContext } from "src/hooks/useApplication";

export function useCreateTopic() {
  const app = useApplicationContext();
  const router = useRouter();
  const topics = useDeepLinks(DeepLinkType.DIGEST_2);

  const createTopic = async ({
    name = "New Topic",
    description = "",
    scope = "private" as "private" | "workspace" | "global",
    state = { data: {}, layout: [] },
    openInTab = true,
  } = {}) => {
    if (!app.org_id) return;
    const link = await topics.create.mutateAsync({
      state,
      name,
      description,
      scope,
    });
    if (link?.id) {
      const url = `/${app.org_id}/topics/${link.id}/edit.v2`;
      if (openInTab && app.appendTab) {
        app.appendTab(name, url, { open: true });
      } else {
        router.push(url);
      }
    }
    return link;
  };

  return {
    createTopic,
    loading: topics.create.isLoading,
    error: topics.create.error,
  };
}
